"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debounce = require("lodash.debounce");
var paused = false;
function pauseHeightChanges() {
    paused = true;
}
exports.pauseHeightChanges = pauseHeightChanges;
function resumeHeightChanges() {
    paused = false;
}
exports.resumeHeightChanges = resumeHeightChanges;
function isPaused() {
    return paused;
}
exports.isPaused = isPaused;
function clamp(value, min, max) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = Infinity; }
    return Math.min(Math.max(value, min), max);
}
exports.clamp = clamp;
function listenToHeightChanges(wixSdk, window, options) {
    if (options === void 0) { options = {}; }
    var lastHeight = window.document.documentElement.offsetHeight;
    var firstRender = true;
    var updateHeight = function () {
        var height = clamp(window.document.documentElement.offsetHeight, options.minHeight, options.maxHeight);
        var shouldSkipResize = window.document.body.offsetHeight === 0 && firstRender;
        if (!shouldSkipResize && !paused) {
            firstRender = false;
            wixSdk.setHeight(height);
        }
    };
    var updateHeightIfChanged = function () {
        if (window.innerHeight !== lastHeight ||
            window.document.documentElement.offsetHeight !== lastHeight) {
            lastHeight = window.document.documentElement.offsetHeight;
            updateHeight();
        }
    };
    var updateHeightWithDebounce = debounce(updateHeightIfChanged, 100, {
        leading: true
    });
    window.addEventListener("resize", updateHeightWithDebounce);
    if (!options.resizeOnly) {
        window.addEventListener("transitionend", updateHeightIfChanged);
        var observer = new window.MutationObserver(updateHeightWithDebounce);
        observer.observe(window.document.body, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
        wixSdk.addEventListener(wixSdk.Events.STYLE_PARAMS_CHANGE, updateHeight);
        updateHeight();
    }
}
exports.listenToHeightChanges = listenToHeightChanges;
//# sourceMappingURL=index.js.map